import React, { useEffect } from 'react';
import { Modal, Radio, Form, Button, message } from '@drip/drip-design';
// @ts-ignore
import { diffInDay } from '@jd/jmtd-tools/dist/date'
import _ from 'lodash';
import apis from '@/pages/mvp-panel/participant-data/apis.js';
const token_1 = 'ceee093c-c2a5-47aa-ba01-87a38d505088'; // 下载全部列表
const token_2 = 'c99ef55e-5e97-4615-8686-d28a19c69cbd'; //下载子表

const modelId_1_SKU = '98d727b7-105c-4f69-a60c-c1b337b9ded6'; //SKU一级列表(页面初始化及未点击任何下钻情况使用):
const modelId_1_SPU = '99e7e57e-c8ac-4917-9566-182aee0a898e'; //SPU一级列表

// const modelId_1 = '1bf7aa39-13aa-4cfb-9e1b-ca207fbbfb18'; // 一级列表 1230迭代新增
const modelId_2 = 'c619b653-a7f9-4a88-9556-44d3d8763c2b'; // 二级列表
const modelId_3 = 'c0808563-129e-4e15-85dc-803e26346d4f'; // 三级列表

export const FILTER_DOWNLOAD = ['supply_chain_standard_last_7_days_item_first_cate_click_band_qtty',
  'supply_chain_standard_last_7_days_item_third_cate_click_band_qtty','supply_chain_standard_last_28_days_item_first_cate_click_band_qtty',
  'supply_chain_standard_last_28_days_item_third_cate_click_band_qtty', 'supply_chain_standard_last_7_days_item_first_cate_deal_band_qtty','supply_chain_standard_last_7_days_item_third_cate_deal_band_qtty',
  'supply_chain_standard_last_28_days_item_first_cate_deal_band_qtty', 'supply_chain_standard_last_28_days_item_third_cate_deal_band_qtty', 'supply_chain_standard_last_7_days_item_first_cate_deal_band_amt',
  'supply_chain_standard_last_7_days_item_third_cate_deal_band_amt','supply_chain_standard_last_28_days_item_first_cate_deal_band_amt','supply_chain_standard_last_28_days_item_first_cate_deal_band_amt',
  'supply_chain_standard_last_28_days_item_third_cate_deal_band_amt','supply_chain_standard_last_7_days_item_first_cate_brand_deal_band_qtty',
  'supply_chain_standard_last_7_days_item_third_cate_brand_deal_band_qtty', 'supply_chain_standard_last_28_days_item_first_cate_brand_deal_band_qtty',
  'supply_chain_standard_last_28_days_item_third_cate_brand_deal_band_qtty', 'supply_chain_standard_last_7_days_item_first_brand_deal_band_amt',
  'supply_chain_standard_last_7_days_item_third_brand_deal_band_amt', 'supply_chain_standard_last_28_days_item_first_brand_deal_band_amt',
  'supply_chain_standard_last_28_days_item_third_brand_deal_band_amt','jdr_sch_on_shelves_sku_value_ser_surp_tag_free_return_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_use', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_custom',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_price_insurance_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_price_insurance_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_damaged_return_self', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_isfzxp_weight',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_unpack', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_not_install',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_return', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_isfzxp_regular',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_30_price_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_48_hour_delivery_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_late_must_pay_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_damaged_return_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_buy_ease', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_return_unsupport', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_audit_speed_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_install_easy', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_good_trend',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_24_hour_delivery_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_replace_onsite_self',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_return', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_tech_freight_insure_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_7_price_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_extend_insure_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_one_year_quality_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_90_price_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_refund_speed_self', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_pickup_onsite_pop',
  'jdr_sch_on_shelves_sku_value_ser_surp_tag_15_price_pop', 'jdr_sch_on_shelves_sku_value_ser_surp_tag_refund_speed_pop'
]
export const BASIC_DOWNLOAD =['brand_name', 'item_cate_name_1', 'shop_name']

function DownloadModal(props: { visible: boolean; setVisible: (val: boolean) => void; conditions: any ,item: any, downloadBySku: boolean, skuGroupId: any, selObj: any}) {
  const { visible, setVisible, conditions, item, downloadBySku, skuGroupId, selObj } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible || !form) return;
    form.resetFields();
  }, [visible, form]);

  const onFinish = (val: any) => {
    const _conditions = _.cloneDeep(conditions);
    const { itemType } = _conditions;

    const diffDay = diffInDay(new Date(_conditions?.endDate), new Date(_conditions?.beginDate))
    if(diffDay >= 7 && val?.timeType === 'total'){
      message.warn('流量类指标数据量过大,为避免下载失败,建议时间跨度在一周以内。')
      setVisible(false);
      return
    }
    let modelId = '';
    let token = token_2;

    if (val.channelType === 'sku_id') {
      modelId = itemType === '1' ? modelId_1_SKU : modelId_1_SPU;
      token = token_1;
    } else if (val.channelType === 'last_src_channel_id_2') {
      modelId = modelId_2;
    } else if (val.channelType === 'last_src_channel_id_3') {
      modelId = modelId_3;
    }
    if(downloadBySku){
      if(itemType === '1' ){
        _conditions.excelName = item?.sku_id;
        _conditions.criteria.sku_id = [item?.sku_id]
      } else if(itemType === '2' ){
        _conditions.excelName = item?.spu_id;
        _conditions.criteria.spu_id = [item?.spu_id]
      }
    }
    // 只有按天能下载band值
    if(val?.timeType === 'total'){
      _conditions.indicators = _.difference(_conditions.indicators, FILTER_DOWNLOAD)
    }
    // 过滤基础属性指标 店铺 品类 品牌
    _conditions.indicators = _.difference(_conditions.indicators, BASIC_DOWNLOAD)
    if(skuGroupId != -1){
      _conditions.skuGroupId = skuGroupId;
    }
    _conditions.groupName = selObj?.skuName;

    apis
      .queryGoodsAnalysis({ ..._conditions, ...val, download: true, token: token, modelId: modelId, total: 40000, downloadBySku: downloadBySku})
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || '导出失败，请稍后重试';
        message.success('导出成功，稍后将会用鲸盘分享给您');
        setVisible(false);
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  return (
    <Modal visible={visible} footer={null} onCancel={() => setVisible(false)} title="导出数据" width={400}>
      <div className="sku-analysis-download-modal">
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={{
            timeType: 'day',
            channelType: 'sku_id',
          }}
        >
          <Form.Item label="时间粒度" name="timeType">
            <Radio.Group>
              <Radio value={'day'}>按天导出</Radio>
              <Radio value={'total'}>汇总导出</Radio>
            </Radio.Group>
          </Form.Item>
          {/*<Form.Item label="数据维度" name="channelType">*/}
          {/*  <Radio.Group>*/}
          {/*    <Radio value={'sku_id'}>全部</Radio>*/}
          {/*    <Radio value={'last_src_channel_id_2'} disabled>*/}
          {/*      一级渠道*/}
          {/*    </Radio>*/}
          {/*    <Radio value={'last_src_channel_id_3'} disabled>*/}
          {/*      二级渠道*/}
          {/*    </Radio>*/}
          {/*  </Radio.Group>*/}
          {/*</Form.Item>*/}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button type="primary" style={{ marginRight: 16 }} htmlType="submit">
              导出
            </Button>
            <Button onClick={() => setVisible(false)}>取消</Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}

export default DownloadModal;
